import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const CategoryContext = createContext();

export const CategoryProvider = ({ children }) => {

    const [categories, setCategories] = useState([]);

    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/categories?b2b=false`);
            setCategories(response.data.categories);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const fetchCategoriesWithCounts = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/categories/with-counts?b2b=false`);
            return response.data.categories;
        } catch (error) {
            console.error('Error fetching categories with counts:', error);
            return [];
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    return (
        <CategoryContext.Provider value={{ categories, fetchCategories, fetchCategoriesWithCounts }}>
            {children}
        </CategoryContext.Provider>
    );
};